'use client';

import { useContext, useEffect, useRef, useState } from 'react';
import styles from './signupOTP.module.scss';
import Image from 'next/image';
import loginImage from 'assets/images/imageLogin.jpg';
import { GlobalContext } from 'context';
import { Form, Input, Button, message } from 'antd';
import { AppStorage, RestAPI, ToEnglish, useAsyncClick } from 'scripts';
import { __RegisterType } from './signupOTP.type';
import { API, PATH } from 'data';
import { JWTTokenType } from 'types';
import { useSearchParams } from 'next/navigation';
import LoginFirstStepComp from './firstStep/firstStep.index';
function LoginOTPComp() {
  const langText = useContext(GlobalContext).langText;
  const lang = langText.signupOTP;
  const [phoneForm] = Form.useForm();
  const [codeForm] = Form.useForm();
  const params = useSearchParams();
  const [step, setStep] = useState<'phone' | 'code'>('phone');
  const [countdown, setCountdown] = useState<number>(0);
  const timer = useRef<NodeJS.Timeout>();
  const noCodeAccess = !!Number(process.env.NEXT_PUBLIC_DISABLE_CODE_REGISTRATION);
  const reSend = () => {
    if (countdown === 0) phoneForm.submit();
  };
  const editPhone = () => {
    phoneForm.setFieldValue('phone', null);
    setStep('phone');
  };
  const onChangeForm = () => {
    const values = codeForm.getFieldsValue();
    codeForm.setFields(Object.keys(values).map(i => ({
      name: i,
      errors: undefined
    })));
  };
  const submitHandler = (value: __RegisterType) => {
    return new Promise(resolve => {
      const phoneValue = phoneForm.getFieldsValue();
      const phone = `${noCodeAccess ? '' : phoneValue.prefix.split('|')[0]}${ToEnglish(phoneValue.phone)}`;
      RestAPI.post<JWTTokenType>(API.middlewares.signup, {
        phone,
        code: ToEnglish(value.code)
      }).then(res => {
        AppStorage.authToken.set(res.data);
        window.location.href = params.get('redirect') ?? PATH(langText.lang).panel.index;
      }).catch(() => {
        message.error(lang.codeSubmitError);
        resolve(true);
      });
    });
  };
  const codeHandler = useAsyncClick(submitHandler);
  useEffect(() => {
    if (countdown > 0) timer.current = setInterval(() => setCountdown(prevCountdown => prevCountdown - 1), 1000);else if (timer.current) {
      clearInterval(timer.current);
      timer.current = undefined;
    }
    return () => {
      if (timer) clearInterval(timer.current);
    };
  }, [countdown]);
  return <div className={`${styles['container']} main-content justify-content-between center-content-y gap-24 pt-5 pb-10 flex-1`} data-sentry-component="LoginOTPComp" data-sentry-source-file="signupOTP.index.tsx">
            <div className={`${styles['form-layout']}`}>
                <div>
                    <h2 className="t-900 t-h3 t-md-h2">{lang.login_title}</h2>
                    <p className="mt-2 t-p2 t-400 mb-3">
                        {step === 'phone' ? lang.login_desc : <>
                                {`${lang.codeDesc1} ${phoneForm.getFieldValue('phone')} ${lang.codeDesc2}`}
                                <span className="t-primary ph-1-i t-p2 pointer" onClick={editPhone}>
                                    {lang.change_phone}
                                </span>
                            </>}
                    </p>
                    <LoginFirstStepComp step={step} phoneForm={phoneForm} onNext={() => {
          setStep('code');
          setCountdown(120);
        }} data-sentry-element="LoginFirstStepComp" data-sentry-source-file="signupOTP.index.tsx" />
                    <Form<__RegisterType> layout="vertical" form={codeForm} onFinish={codeHandler.onClick} onChange={onChangeForm} className={step === 'code' ? '' : 'd-none-i'} data-sentry-element="Form" data-sentry-source-file="signupOTP.index.tsx">
                        <Form.Item<__RegisterType> className={`mb-2-i ${styles['ltr-input']}`} name="code" rules={[{
            required: true,
            message: lang.codeRequired
          }]} label={<p className="t-500 t-p2">{lang.code}</p>} validateTrigger={false} data-sentry-element="unknown" data-sentry-source-file="signupOTP.index.tsx">
                            <Input.OTP size="large" length={5} variant="filled" data-sentry-element="unknown" data-sentry-source-file="signupOTP.index.tsx" />
                        </Form.Item>
                        <p>
                            {lang.resend_code_first}{' '}
                            <span className={`${countdown === 0 ? 't-primary pointer' : ''}`} onClick={reSend}>
                                {lang.resend_code_second}
                            </span>{' '}
                            <span className={`${countdown === 0 ? 'd-none' : ''}`}>
                                {lang.resend_code_third} {countdown} {lang.resend_code_end}
                            </span>
                        </p>
                        <Form.Item className="m-0-i" data-sentry-element="unknown" data-sentry-source-file="signupOTP.index.tsx">
                            <Button loading={codeHandler.loading} htmlType="submit" className={`w-100 mt-5`} data-sentry-element="Button" data-sentry-source-file="signupOTP.index.tsx">
                                {lang.login_account}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className={`${styles['image-layout']} d-pre-md-none`}>
                <Image src={loginImage} alt="login image" width={645} height={539} className="w-100" data-sentry-element="Image" data-sentry-source-file="signupOTP.index.tsx" />
            </div>
        </div>;
}
export default LoginOTPComp;